import { useState } from 'react'

import { MissingAgreementDataQueryVariables } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ActivationCenterButton } from 'modules/finance/components/FinancialWorkspace/components/ActivationCenter/BaseButton'
import { REQUEST_SOURCE } from 'modules/finance/components/FinancialWorkspace/consts/requestSource'
import { EmployeesWithMissingAgreementsModal } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/components/MissingGrossSalaries/Modal'
import { CustomValues } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/components/MissingGrossSalaries/types'
import { ReturnedData } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/hooks/useMissingAgreementData'

interface Props {
  data: ReturnedData
  buttonType?: 'upgrade' | 'outline'
  customValues?: CustomValues
  variables: MissingAgreementDataQueryVariables
  fromComponent: string
}

export const MissingGrossSalariesButton = ({
  data,
  buttonType = 'outline',
  customValues,
  variables,
  fromComponent,
}: Props) => {
  const [modalOpen, setModalOpen] = useState(false)

  const handleOpenModal = () => {
    setModalOpen(true)

    track(trackingEvents.accounting.newFinancialWorkspace.grossSalaryMissingData.modalOpened, {
      source: `${REQUEST_SOURCE} - ${fromComponent}`,
    })
  }

  const handleCloseModal = () => {
    setModalOpen(false)

    track(trackingEvents.accounting.newFinancialWorkspace.grossSalaryMissingData.modalClosed, {
      source: `${REQUEST_SOURCE} - ${fromComponent}`,
    })
  }

  return (
    <>
      <ActivationCenterButton
        buttonType={buttonType}
        handleOpenModal={handleOpenModal}
        text={customValues?.buttonText || i18n.t('finance.financial_workspace.missing_data.cta')}
      />
      {modalOpen && (
        <EmployeesWithMissingAgreementsModal
          data={data}
          variables={variables}
          onClose={handleCloseModal}
        />
      )}
    </>
  )
}
